import { query, download } from "../../defaults/fetch";

/**
 * Hook for fetching a single user's payslip data
 * @returns {Function} Function to fetch payslip data
 */
export const useGetPayslip = () => {
  const getPayslip = async (userId, financialYearId, yearMonth) => {
    const url = `payroll/payslips/${userId}/${financialYearId}/${yearMonth}`;
    const response = await query(url);
    return response?.data || null;
  };
  return getPayslip;
};

/**
 * Hook for downloading a single user's payslip as PDF
 * @returns {Function} Function to download payslip PDF
 */
export const useDownloadPayslip = () => {
  const downloadPayslip = async (userId, financialYearId, yearMonth, employeeName) => {
    const url = `payroll/payslips/${userId}/${financialYearId}/${yearMonth}/pdf`;
    const filename = `Payslip_${employeeName}_${yearMonth}`;
    await download(url, filename, 'pdf', false);
  };
  return downloadPayslip;
};

/**
 * Hook for fetching all payslips for a specific month and year
 * @returns {Function} Function to fetch bulk payslips
 */
export const useGetBulkPayslips = () => {
  const getBulkPayslips = async (financialYearId, yearMonth) => {
    const url = `payroll/payslips/bulk/${financialYearId}/${yearMonth}`;
    const response = await query(url);
    return response?.data || [];
  };
  return getBulkPayslips;
};

/**
 * Hook for downloading all payslips for a specific month and year as a single PDF
 * @returns {Function} Function to download bulk payslip PDF
 */
export const useDownloadBulkPayslips = () => {
  const downloadBulkPayslips = async (financialYearId, yearMonth) => {
    const url = `payroll/payslips/bulk/${financialYearId}/${yearMonth}/pdf`;
    const filename = `Payslips_${yearMonth}.zip`;
    await download(url, filename, 'zip', false);
  };
  return downloadBulkPayslips;
};

/**
 * Hook for downloading salary table as Excel for a specific month and year
 * @returns {Function} Function to download salary table as Excel
 */
export const useDownloadSalaryTable = () => {
  const downloadSalaryTable = async (financialYearId, yearMonth) => {
    const url = `payroll/payslips/bulk/${financialYearId}/${yearMonth}/excel`;
    const filename = `Salary_Table_${yearMonth}.xlsx`;
    await download(url, filename, 'xlsx', false);
  };
  return downloadSalaryTable;
};
